import {
    Button,
    Divider,
    Form,
    Input,
    message,
    Space,
    Tag,
    Typography,
    Modal
  } from "antd";
  import React, { useState, useRef } from "react";
  import { useNavigate } from "react-router";
import ResponseMessage from "../../Comman/Notification/ResponseMessge";
  
  const { Title, Text } = Typography;
  
  const BinOutwardWash = ({ userData }) => {
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [scannedData, setScannedData] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [scannedValue, setScannedValue] = useState("");
    const scannerRef = useRef(null);
    const [startScan, setStartScan] = useState(false);
    const navigate = useNavigate();
    const [form] = Form.useForm();
  
    const handleTagClick = () => {
        setIsModalVisible(true);
        setStartScan(true);
        scannerRef.current?.startScanner();
    };
  
    const handleScan = (value) => {
        onFinish(value);
        setScannedValue(value);
    };
  
    const onFinish = async (values) => {
        try {
            const dataToSubmit = values.binId || values;
            setScannedData(dataToSubmit);
  
            if (!dataToSubmit) {
                ResponseMessage.error("Please provide valid scanned data or enter it manually");
                return;
            }
  
            setIsSubmitted(true);
            setIsLoading(true);
  
            navigate(`/wash/bin/sendtogsm/confirm?binId=${encodeURIComponent(dataToSubmit)}`);
  
  
        } catch (error) {
            console.error('Error:', error);
            setIsLoading(false);
            ResponseMessage.error("An error occurred while fetching data.");
            setIsSubmitted(false);
        }
    };
  
    return (
        <>
  
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Tag
                    style={{
                        width: "300px",
                        height: "90px",
                        color: "#2db7f5",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#2db7f5",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                        borderRadius: "10px",
                    }}
                    color="#2db7f5"
                    onClick={handleTagClick}
                >
                    <Text strong style={{ fontSize: "20px", color: "white", fontWeight: "bold" }}>
                        SCAN HERE
                    </Text>
                </Tag>
  
                <Space block size="large" style={{ padding: "20px 0" }}>
                    <Text strong>OR</Text>
                </Space>
  
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", width: "100%" }}>
                    <Form
                        name="form_item_path"
                        layout="vertical"
                        onFinish={onFinish}
                        form={form}
                        style={{ width: "300px" }}
                    >
                        <Form.Item name="binId" label="Enter Bin ID Manually"
                            rules={[
                                {
                                    required: true,
                                    message: "Bin ID cannot be empty. Please provide a valid ID."
                                }
                            ]}>
                            <Input autoFocus size="large" style={{ width: "100%", textAlign: "center" }} />
                        </Form.Item>
  
                        <Form.Item>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <Button type="primary" htmlType="submit">
                                    Submit
                                </Button>
                            </div>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </>
    );
  };
  
  export default BinOutwardWash;
  